import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/components/login/login';
import { ForgotPasswordModalComponent } from './features/login/components/modals/forgot-password-modal/forgot-password-modal.component';
import { ChatLayoutComponent } from './features/chat/components/chat-layout/chat-layout';
import { AuthGuard, GuestGuard, TenantGuard } from './shared/guards';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [GuestGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordModalComponent,
    canActivate: [GuestGuard]
  },
  {
    path: ':tenant/chat',
    component: ChatLayoutComponent,
    canActivate: [AuthGuard, TenantGuard]
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];
